import { callAPI } from "@/api/httpservice";
import type {
  ClusterData,
  KitData,
  SiteData,
} from "@/types/clusterSiteKit.types";
import type { User, UserData } from "@/types/user.types";

// SITE MANAGEMENT
export function apiFetchActiveSites() {
  return callAPI<{ items: SiteData[]; total: number }>(
    "GET",
    `/sites?limit=100&page=1&activesOnly=true`
  );
}

export function fetchSiteData(limit: number, page: number, search: string, getSystem?:boolean) {
  return callAPI<{ items: SiteData[]; total: number }>(
    "GET",
    `/sites?limit=${limit}&page=${page}&search=${search}${getSystem ? "&getSystem=true" : ""}`
  );
}

export function apiPostSite(name: string) {
  return callAPI<SiteData>("POST", `/sites`, { name });
}

export function apiPostSites(payload: { names: string[] }) {
  return callAPI<SiteData[]>("POST", `/sites`, payload);
}

export function updateSite(id: string, name: string) {
  return callAPI<SiteData>("PATCH", `/sites/${id}`, { name });
}

export function apiUpdateSiteStatus(id: string, isActive: boolean) {
  return callAPI<SiteData>("PATCH", `/sites/${id}`, { isActive });
}

export function deleteSite(id: string) {
  return callAPI<SiteData>("DELETE", `/sites/${id}`, null);
}

// KIT MANAGEMENT
export function fetchKitData(limit: number, page: number, search: string, getSystem?:boolean) {
  return callAPI<{ items: KitData[]; total: number }>(
    "GET",
    `/kits?limit=${limit}&page=${page}&search=${search}${getSystem ? "&getSystem=true" : ""}`
  );
}

export function apiPostKit(name: string, user?: User) {
  return callAPI<KitData>("POST", `/kits`, { name, userId: user?.id });
}

export function apiUpdateKit(id: string, name: string, isActive: boolean) {
  return callAPI<KitData>("PATCH", `/kits/${id}`, { name, isActive });
}

export function apiUpdateKitPhotograher(id: string, userId: string) {
  return callAPI<KitData>("PATCH", `/users/${userId}/kit/${id}`, null);
}

export function deleteKit(id: string) {
  return callAPI<KitData>("DELETE", `/kits/${id}`, null);
}

// CLUSTER MANAGEMENT
export function apiUpdateClusterStatus(id: string, isActive: boolean) {
  return callAPI<ClusterData>("PATCH", `/clusters/${id}`, { isActive });
}

export function fetchClusterData(limit: number, page: number, search: string, getSystem?:boolean) {
  return callAPI<{ items: ClusterData[]; total: number }>(
    "GET",
    `/clusters?limit=${limit}&page=${page}&search=${search}${getSystem ? "&getSystem=true" : ""}`
  );
}

export function fetchOneCluster(id: string) {
  return callAPI<ClusterData>("GET", `/clusters/${id}`, null);
}

export function createCluster(name: string, sitesIds: string[]) {
  return callAPI<ClusterData>("POST", `/clusters`, { name, sitesIds });
}

export function deleteCluster(id: string) {
  return callAPI<ClusterData>("DELETE", `/clusters/${id}`, null);
}

export function updateCluster(id: string, name: string, sitesIds?: string[]) {
  return callAPI<SiteData>("PATCH", `/clusters/${id}`, { name, sitesIds });
}

export function assignSiteToUser( userId: string, siteId: string) {
  return callAPI<UserData>(
    "PATCH", `/users/${userId}/site/${siteId}`, null
  );
}

export function assignKitToUser( userId: string, kitId: string) {
  return callAPI<UserData>(
    "PATCH", `/users/${userId}/kit/${kitId}`, null
  );
}